import debounce from 'lodash/debounce';

class Accordion {
    constructor($element) {
        this.$accordion = $element;
        this.$items = this.$accordion.querySelectorAll('.accordion-item');

        this.events();
    }

    events() {
        [...this.$items].forEach($item => {
            let $trigger = $item.querySelector('.accordion-trigger'),
                $body = $item.querySelector('.accordion-body');

            $trigger.addEventListener('click', this.toggle.bind(this, $trigger, $body));
        });

        window.addEventListener('resize', debounce(this.handleResize.bind(this), 100));
    }

    toggle($trigger, $body) {
        let doClose = $trigger.getAttribute('aria-expanded') === 'true';

        $body.style.height = $body.querySelector('.accordion-body-inner').offsetHeight + 'px';
        $trigger.setAttribute('aria-expanded', !doClose);
        $body.setAttribute('aria-hidden', doClose);
        $body.setAttribute('tabindex', doClose ? '-1' : '0');
    }

    handleResize() {
        [...this.$accordion.querySelectorAll('[aria-hidden="false"]')].forEach($body => {
            $body.style.height = $body.querySelector('.accordion-body-inner').offsetHeight + 'px';
        });
    }
}

export default Accordion;
